(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lunerisse-product-slides"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lunerisse-product-slides')) {
    customElements.define('lunerisse-product-slides', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.timer = null;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.playing = this.dataset.autoplay === 'true' && !this.reduced.matches;
        if (this.slides.length < 2) return;
        this.querySelector('[data-controls]').hidden = false;
        this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.move(1, true), options);
        this.querySelector('[data-play]').addEventListener('click', () => {
          this.playing = !this.playing;
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => this.clearTimer(), options);
        this.addEventListener('mouseleave', () => this.schedule(), options);
        this.addEventListener('focusin', event => {
          if (event.target.closest('[data-play]')) { this.clearTimer(); return; }
          this.playing = false;
          this.schedule();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1, true);
          }
        }, options);
        this.addEventListener('touchstart', event => {
          this.touchX = event.changedTouches[0].clientX;
          this.touchY = event.changedTouches[0].clientY;
          this.clearTimer();
        }, { ...options, passive: true });
        this.addEventListener('touchend', event => {
          const dx = event.changedTouches[0].clientX - this.touchX;
          const dy = event.changedTouches[0].clientY - this.touchY;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) this.move(dx < 0 ? 1 : -1, true);
          else this.schedule();
        }, { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.reduced.addEventListener('change', event => {
          if (event.matches) { this.playing = false; this.schedule(); }
        }, options);
        this.schedule();
      }
      clearTimer() { clearTimeout(this.timer); this.timer = null; }
      schedule() {
        this.clearTimer();
        this.querySelector('[data-play]').setAttribute('aria-pressed', String(this.playing));
        this.querySelector('[data-play-icon]').textContent = this.playing ? 'Ⅱ' : '▶';
        this.querySelector('.lune-slides__viewport').setAttribute('aria-live', this.playing ? 'off' : 'polite');
        if (this.playing && !document.hidden && !this.matches(':hover')) this.timer = setTimeout(() => this.move(1, false), 6000);
      }
      move(direction, manual) {
        if (manual) this.playing = false;
        this.index = (this.index + direction + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
        this.querySelector('[data-current]').textContent = this.index + 1;
        if (manual) this.querySelector('[data-status]').textContent = this.slides[this.index].querySelector('h1,h2').textContent + ' · ' + (this.index + 1) + ' / ' + this.slides.length;
        this.schedule();
      }
      disconnectedCallback() { this.clearTimer(); this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
